import React from 'react'
import { graphql } from 'gatsby'
import PageBottomFeatImage from './commonTemplates/pageBottomFeatImage'
import PageLeftFeatImage from './commonTemplates/pageLeftFeatImage'
import PageTopOnlyFeatImage from './commonTemplates/pageTopOnlyFeatImage'
import { EDU_PAGE_SLUG } from '../lib/constants'
import { useTranslation } from 'react-i18next'

export function Head({ data: { eduPage: page } }) {
    const { t } = useTranslation()

    return (
        <>
            <title>{page.title} | {t('seo-title-suffix')}</title>
            <meta name="description" content={page?.metaDesc} />
            <meta property="og:url" content={`${process.env.GATSBY_SITE_URL}/${EDU_PAGE_SLUG}/${page.slug}`} />
            <meta property="og:type" content="article" />
            <meta property="og:title" content={page.title} />
            <meta property="og:image" content={page?.featuredImage?.url} />
            <meta property="og:locale" content={page.node_locale} />
        </>
    )
}

const EduPage = ({ pageContext, data: { eduPage: p } }) => {
    switch (p.useTemplate) {
        case 'TopOnlyFeaturedImage':
            return <PageTopOnlyFeatImage page={p} context={pageContext} />
        case 'LeftFeaturedImage':
            return <PageLeftFeatImage page={p} context={pageContext} />
        case 'BottomFeaturedImage':
            return <PageBottomFeatImage page={p} context={pageContext} />
        default:
            return <PageTopOnlyFeatImage page={p} context={pageContext} />
    }
}

export const query = graphql`
    query FetchEduLevel($slug: String, $lang: String) {
        eduPage: contentfulEduPage(slug: { eq: $slug }, node_locale:{eq: $lang}) {
            title
            slug
            subtitle
            metaDesc
            useTemplate
            node_locale
            blogTags
            blogCategory
            body {
                raw
                references {
                    ... on ContentfulAsset {
                        contentful_id
                        mimeType
                        title
                        description
                        internal {
                            type
                        }
                        gatsbyImageData(
                            placeholder: BLURRED
                            height: 1920
                            width: 1920
                            quality: 75
                            sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                            layout: FULL_WIDTH
                            breakpoints: [576, 768, 960, 1200, 1920]
                        )
                        url
                    }
                }
            }
            attachments {
                file {
                    url
                    fileName
                    contentType
                }
                description
                title
                url
            }
            featuredImage {
                title
                description
                url
                gatsbyImageData(
                    placeholder: BLURRED
                    height: 1920
                    width: 1920
                    quality: 75
                    sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                    layout: FULL_WIDTH
                    breakpoints: [576, 768, 960, 1200, 1920]
                )
            }
            gallery {
                title
                description
                width
                height
                url
                gatsbyImageData(
                    placeholder: BLURRED
                    height: 1920
                    width: 1920
                    quality: 75
                    sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                    layout: FULL_WIDTH
                    breakpoints: [576, 768, 960, 1200, 1920]
                )
            }
            eduPageBlockTitle
            eduPageBlockSubtitle
            accordion {
                title
                body {
                    raw
                    references {
                        ... on ContentfulAsset {
                            contentful_id
                            mimeType
                            title
                            description
                            internal {
                                type
                            }
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 1920
                                width: 1920
                                quality: 75
                                sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                                layout: FULL_WIDTH
                                breakpoints: [576, 768, 960, 1200, 1920]
                            )
                            url
                        }
                    }
                }
                attachments {
                    file {
                        url
                        fileName
                        contentType
                    }
                    description
                    title
                    url
                }
                gallery {
                    title
                    description
                    width
                    height
                    url
                    gatsbyImageData(
                        placeholder: BLURRED
                        height: 1920
                        width: 1920
                        quality: 75
                        sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                        layout: FULL_WIDTH
                        breakpoints: [576, 768, 960, 1200, 1920]
                    )
                }
            }
        }
    }
`

export default EduPage
